import { render, staticRenderFns } from "./PurScL_Search.vue?vue&type=template&id=65e68d9b"
import script from "./PurScL_Search.vue?vue&type=script&lang=js"
export * from "./PurScL_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports